export const APP_CONSENT_MESSAGES = {
  CHECK_LOADING:
    "Hold on! We're checking in to ensure your preferences are up to date.",
  LOADING: "Hold on! We're checking...",
  ERROR:
    "Oops! We couldn't retrieve your consent details. Please check your connection or try again later. Please contact us if the problem persists.",
};

export const DAILY_PULSE_CHECK_MESSAGES = {
  LOADING:
    "Just a moment! We're checking in on how your day is going. Your feelings matter!",
};
